export enum GuidelineImportErrorCode {
  None,
  GuidelineNotFound,
  ImportNotAllowed,
  GuidelineNotPublished,
  SameOrganisation,
  NotLicensedForHub,
  PaidGuidelineLimitExceeded,
  AlreadyImported,
}
